module.exports = __webpack_public_path__ + "static/img/0546_7.b259e54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0546_7.jpg
// module id = 90ZB
// module chunks = 1